import { FC, useMemo } from 'react';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { IModalComponentProps } from '@context/modal_context';
import { ETwoFAMethod } from '@xeppt/xeppt-sdk/types';

const EnableMFA: FC<IModalComponentProps<{ type: Exclude<ETwoFAMethod, ETwoFAMethod.NONE> }>> = ({
    modalData
}) => {
    const renderText = useMemo(() => {
        switch (modalData.type) {
            case ETwoFAMethod.EMAIL:
                return {
                    first: 'email',
                    second: 'sent to your primary email address'
                };
            case ETwoFAMethod.SMS:
                return {
                    first: 'SMS',
                    second: 'sent to your primary phone number'
                };
            case ETwoFAMethod.TOTP:
                return {
                    first: 'authentication app',
                    second: 'from the app'
                };
            default:
                return {
                    first: '',
                    second: ''
                };
        }
    }, [modalData]);
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4" weight="bold" alignment="center">
                Enable Two-factor authentication
            </Typography>
            <div className={styles.content}>
                <Typography variant="body3" alignment="center">
                    When 2FA is enabled for {renderText.first} you will be required to enter a
                    verification code {renderText.second} every time you sign in
                </Typography>
            </div>
        </div>
    );
};

export default EnableMFA;
